import React, { Component } from 'react'
import { StaticBox, LinkedInput, LinkedToggle, LinkedInputGroup } from 'components/basic'
import { notify, FormHelper } from 'helpers'
import http from 'API/http'
import { connect } from 'react-redux'
class User extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: null,
      editable: false
    }
  }
  componentDidMount () {
    this.setUser(this.props.user)
  }
  componentWillReceiveProps (props) {
    if (props.user === this.props.user) return
    this.setUser(props.user)
  }

  setUser (user) {
    this.setState({user: {...user, password: ''}})
  }

  async saveUser () {
    var valid = await FormHelper.validate(this.form)
    if (!valid) return
    var [err, res] = await http.put('2.4/users/' + this.state.user.userId, this.state.user)
    if (err) return notify.alert('', res.cause ? res.cause : 'Updating  user failed', 'error')
    notify.success('User saved')
    this.setState({editable: false})
  }

  render () {
    if (!this.state.user) return false
    return (
      <StaticBox cols={12} icon='user' title={`${this.state.user.name}`} buttons={[
        { icon: 'fa-save', event: () => this.saveUser(), datatip: 'Save', hidden: (!this.state.editable && !this.state.create) },
        { icon: 'fa-edit', event: () => this.setState({editable: true}), datatip: 'Edit', hidden: this.state.editable }
      ]}>
        <div className='row'>
          <LinkedInputGroup ref={(form) => { this.form = form }}>
            <div className='col-md-3'>
              <label>Name</label>
              <LinkedInput context={this} editable={this.state.editable} path='user.name' validate={/.{1,}/} errorMessage='This field is required' />
            </div>
            <div className='col-md-3'>
              <label>Email</label>
              <LinkedInput context={this} editable={this.state.editable} path='user.email' validate={/^\S+@\S+\.\S+$/} errorMessage='Wrong format' />
            </div>
            {this.state.editable &&
            <div className='col-md-3'>
              <label>Password</label>
              <LinkedInput type='password' context={this} editable={this.state.editable} path='user.password' validate={(this.state.user.password.length !== 0 && /^((?!.*[\s])(?=.*[A-Öa-ö0-9]).{8,100})/)} errorMessage='Minimum of 8 characters in length' name='password' />
            </div>
            }
          </LinkedInputGroup>
          {this.props.siteReducer.user.admin &&
            <div className='col-md-3'>
              <label>Administrator</label>
              <LinkedToggle context={this} disabled={!this.state.editable} path='user.isAdmin' name='Administrator' />
            </div>
          }

        </div>
      </StaticBox>
    )
  }
}
//eslint-disable-next-line
User = connect(state => state)(User)
export default User



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/users/UserEditor.js